// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --video-container-message-bkg: rgba(0, 0, 0, 0.4);
    --video-container-message-color: white;
}
.video-container-message {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    position: absolute;
    left: 0px;
    top: 0px;
    bottom: 0px;
    right: 0px;
    padding-top: 1%;
    pointer-events: none;
    container-type: size;
    container-name: video-container-message;
}

.video-container-message .container {
    width: 31%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 30%;
}

.video-container-message .container .message-content {
    background-color: var(--video-container-message-bkg);
    border-radius: 5px;
    padding-left: 10%;
    padding-right: 10%;
    text-align: center;
    width: 40%;
}

.video-container-message .container .message-content .text {
    text-shadow: 0px 0px 3px var(--video-container-message-bkg);
    color: var(--video-container-message-color);
    width: 100%;
}

.video-container-message .container .message-content i {
    display: inline-block;
    width: 90%;
    padding-top: 10%;
}

.video-container-message .container .message-content i svg {
    width: 100%;
    height: 100%;
    fill: var(--video-container-message-color);
    color: var(--video-container-message-color);
}

@container video-container-message (max-width: 700px) {
    .video-container-message .container .message-content .text {
        font-size: 1.2em;
    }
}

@container video-container-message (min-width: 700px) and (max-width: 1300px) {
    .video-container-message .container .message-content .text {
        font-size: 2.0em;
    }
}

@container video-container-message (min-width: 1300px) {
    .video-container-message .container .message-content .text {
        font-size: 2.3em;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/VideoContainerMessage.css"],"names":[],"mappings":"AAAA;IACI,iDAAiD;IACjD,sCAAsC;AAC1C;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oDAAoD;IACpD,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,2DAA2D;IAC3D,2CAA2C;IAC3C,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[":root {\n    --video-container-message-bkg: rgba(0, 0, 0, 0.4);\n    --video-container-message-color: white;\n}\n.video-container-message {\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: wrap;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    bottom: 0px;\n    right: 0px;\n    padding-top: 1%;\n    pointer-events: none;\n    container-type: size;\n    container-name: video-container-message;\n}\n\n.video-container-message .container {\n    width: 31%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    height: 30%;\n}\n\n.video-container-message .container .message-content {\n    background-color: var(--video-container-message-bkg);\n    border-radius: 5px;\n    padding-left: 10%;\n    padding-right: 10%;\n    text-align: center;\n    width: 40%;\n}\n\n.video-container-message .container .message-content .text {\n    text-shadow: 0px 0px 3px var(--video-container-message-bkg);\n    color: var(--video-container-message-color);\n    width: 100%;\n}\n\n.video-container-message .container .message-content i {\n    display: inline-block;\n    width: 90%;\n    padding-top: 10%;\n}\n\n.video-container-message .container .message-content i svg {\n    width: 100%;\n    height: 100%;\n    fill: var(--video-container-message-color);\n    color: var(--video-container-message-color);\n}\n\n@container video-container-message (max-width: 700px) {\n    .video-container-message .container .message-content .text {\n        font-size: 1.2em;\n    }\n}\n\n@container video-container-message (min-width: 700px) and (max-width: 1300px) {\n    .video-container-message .container .message-content .text {\n        font-size: 2.0em;\n    }\n}\n\n@container video-container-message (min-width: 1300px) {\n    .video-container-message .container .message-content .text {\n        font-size: 2.3em;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
